<script lang="ts" setup>
import { FieldZonesLayer } from '@collector/mobile-feature-field-zones'
import { Pitch } from '@collector/shared-feature-pitch'
import { ParticipantLogo, ParticipantName } from '@collector/shared-ui-domain'
import VolleyballPitchSvg from '@collector/shared-ui-domain/assets/volleyball/pitch.svg'
import { TeamSide } from '@collector/sportsapi-client-legacy'
import GroupTitle from '@mobile/views/Relation/DetailsPanel/Modals/IncidentDetailsModal/GroupTitle.vue'
import { useEventInjections } from '@mobile/views/Relation/Shared/RelationDependencies/useEventInjections'
import ChangeSidesButton from '@mobile/views/Relation/Shared/SidesSwitchOverlay/ChangeSidesButton.vue'

interface Props {
  incidentParticipantTeamSide: TeamSide
}
defineProps<Props>()

// model
const selectedZoneModel = defineModel<number | null>('selectedZone', {
  default: null,
})

// composables
const { sidesSwitched, probableFirstParticipant, probableSecondParticipant } =
  useEventInjections()
</script>

<template>
  <div class="mx-auto w-3/4 space-y-2">
    <div class="relative flex justify-center">
      <div>
        <GroupTitle
          name="Zone"
          important
          :isFulfilled="selectedZoneModel !== null"
        />
      </div>
      <div class="absolute right-0">
        <ChangeSidesButton />
      </div>
    </div>
    <div>
      <div class="flex justify-between py-2 font-bold">
        <div class="flex items-center space-x-2">
          <ParticipantLogo :participant="probableFirstParticipant" />
          <ParticipantName :participant="probableFirstParticipant" />
        </div>

        <div
          class="flex flex-row-reverse items-center space-x-2 space-x-reverse"
        >
          <ParticipantLogo :participant="probableSecondParticipant" />
          <ParticipantName :participant="probableSecondParticipant" />
        </div>
      </div>

      <Pitch
        :pitchImageSrc="VolleyballPitchSvg"
        pitchImageClass="opacity-50"
      >
        <template #overlays>
          <FieldZonesLayer
            v-model:selectedZone="selectedZoneModel"
            :teamSidesChanged="sidesSwitched"
            :incidentParticipantTeamSide
          />
        </template>
      </Pitch>
    </div>
  </div>
</template>
